import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Trophy } from "lucide-react";
import { t } from "@/i18n";

const RANK_STYLES = [
  "rank-gold border-l-2",
  "rank-silver border-l-2",
  "rank-bronze border-l-2",
];

const RANK_COLORS = ["#FFD700", "#C0C0C0", "#CD7F32"];

const DISPLAY_NAMES = { "Koebenhavn": "København" };
const displayName = (name) => DISPLAY_NAMES[name] || name;

const formatAmount = (amount) => {
  return new Intl.NumberFormat("da-DK", {
    style: "currency",
    currency: "DKK",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const LeaderboardCard = ({ title, data, showAmounts = true, valueKey = "total", labelSuffix = "", lang = "da" }) => {
  return (
    <Card
      className="bg-card border-border shadow-none animate-fade-in-up opacity-0 stagger-2"
      data-testid="leaderboard-card"
    >
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          <Trophy className="w-4 h-4 text-[#FFD700]" />
          <CardTitle className="text-sm font-bold tracking-tight">{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        {data.map((item, i) => {
          const rank = i + 1;
          const value = item[valueKey] || 0;
          const maxValue = data[0]?.[valueKey] || 1;
          const percentage = (value / maxValue) * 100;

          return (
            <div
              key={item.department || i}
              className={`relative flex items-center gap-3 p-3 rounded-lg bg-secondary/50 hover:bg-secondary transition-colors duration-200 ${
                i < 3 ? RANK_STYLES[i] : "border-l-2 border-transparent"
              }`}
              data-testid={`leaderboard-row-${rank}`}
            >
              <div
                className="flex items-center justify-center w-7 h-7 rounded-full text-[13px] font-bold shrink-0"
                style={{
                  backgroundColor: i < 3 ? `${RANK_COLORS[i]}20` : "rgba(255,255,255,0.05)",
                  color: i < 3 ? RANK_COLORS[i] : "#A1A1AA",
                }}
              >
                {rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-semibold text-foreground truncate">
                    {displayName(item.department)}
                  </span>
                  <span className="text-sm font-kpi text-foreground ml-2 shrink-0">
                    {showAmounts ? formatAmount(value) : t(lang, "pcs", value)}
                    {labelSuffix}
                  </span>
                </div>
                <div className="w-full h-1 bg-secondary rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${percentage}%`,
                      backgroundColor: i < 3 ? RANK_COLORS[i] : "#FF2A6D",
                      opacity: i < 3 ? 0.7 : 0.4,
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
